import { ParsedUrlQuery } from "querystring";
import type { NextRouter } from "next/router";

interface IRouter {
  asPath: string;
  basePath: string;
  pathName: string;
  query: ParsedUrlQuery;
  route: string;
}

export const setRouterHistory = (Router: NextRouter) => {
  const storage = globalThis?.sessionStorage;
  if (!storage) return;
  const currentRouter: IRouter = {
    asPath: Router.asPath,
    basePath: Router.basePath,
    pathName: Router.pathname,
    query: Router.query,
    route: Router.route,
  };
  const prevPath = storage.getItem("currentPath") || JSON.stringify(currentRouter);
  storage.setItem("prevPath", prevPath);
  storage.setItem("currentPath", JSON.stringify(currentRouter));
};

export const getPrevRouterHistory = (): IRouter => {
  const storage = globalThis?.sessionStorage;
  const prevPath = JSON.parse(storage.getItem("prevPath") as string);
  return prevPath;
};
